<template>
  <el-container id="adb">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name:"adb",
  data() {
    return {
      h_text:"能耗统计",
      li_h_text:[
        {"text":"节能统计","colour":"#B7B7B7","pages":""}
      ]
    };
  },
  methods:{ /*方法存放*/

  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#adb {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

.div_left {
  background: #F4F4F4;
}
</style>



// WEBPACK FOOTER //
// src/components/dataEnergy.vue